// extracted by mini-css-extract-plugin
export var active = "_9h-d";
export var blink = "_9h-e";
export var container = "_9h-5";
export var controls = "_9h-0";
export var controlsRight = "_9h-1";
export var fakeCursor = "_9h-c";
export var hidden = "_9h-b";
export var quillContainerSmall = "_9h-7";
export var quillEditor = "_9h-6";
export var quillEditorSmall = "_9h-8";
export var quillFormatButtons = "_9h-a";
export var quillToolbar = "_9h-9";
export var removePadding = "_9h-2";
export var state = "_9h-3";
export var stateTitle = "_9h-4";